import {
  FETCH_COMPANY_DETAILS,
  FETCH_COMPANY_DETAILS_SUCCESS,
  FETCH_COMPANY_DETAILS_FAIL,
  UPDATE_COMPANY_DETAILS,
  UPDATE_COMPANY_DETAILS_SUCCESS,
  UPDATE_COMPANY_DETAILS_FAIL,
  CREATE_COMPANY_DETAILS,
  CREATE_COMPANY_DETAILS_SUCCESS,
  CREATE_COMPANY_DETAILS_FAIL,
} from "./actionTypes"

const initialState = {
  companyDetails: null,
  loading: false,
  updating: false,
  error: null,
}

const company = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COMPANY_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case FETCH_COMPANY_DETAILS_SUCCESS:
      return {
        ...state,
        companyDetails: action.payload,
        loading: false,
        error: null,
      }

    case FETCH_COMPANY_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    case UPDATE_COMPANY_DETAILS:
    case CREATE_COMPANY_DETAILS:
      return {
        ...state,
        updating: true,
        error: null,
      }

    case UPDATE_COMPANY_DETAILS_SUCCESS:
    case CREATE_COMPANY_DETAILS_SUCCESS:
      return {
        ...state,
        companyDetails: action.payload,
        updating: false,
        error: null,
      }

    case UPDATE_COMPANY_DETAILS_FAIL:
    case CREATE_COMPANY_DETAILS_FAIL:
      return {
        ...state,
        updating: false,
        error: action.payload,
      }

    default:
      return state
  }
}

export default company

// Selectors
export const selectCompanyDetails = (state) => state.company.companyDetails
export const selectCompanyLoading = (state) => state.company.loading
export const selectCompanyUpdating = (state) => state.company.updating
export const selectCompanyError = (state) => state.company.error
